import axios from 'axios';
import router from '../router';
import { ElMessage } from 'element-plus';

const baseURL = process.env.VUE_APP_BASE_API;

// 创建 axios 实例
const service = axios.create({
    baseURL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json'
    }
    // 配置项
});

//post请求头的设置
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// request interceptor
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        // do something with request error
        // console.log(error) // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        // if the custom code is not 20000, it is judged as an error.
        if (res.code != 200) {
            ElMessage({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            });
        } else {
            return res;
        }
    },
    error => {
        console.log(error) // for debug
        ElMessage({
            message: error.response.data.msg,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;
